import { h, Fragment } from "preact";
import { useContext } from "preact/hooks";
import CardTemplate from "./CardTemplate";
import {

    Box,
    Paper,
    Typography,
    Stack,

} from "@mui/material";

import { AppContext } from "../../AppContext";
import ButtonWithTooltipAndBadge from "./ButtonWithTooltipAndBadge";

import AlarmOnIcon from "@mui/icons-material/AlarmOn";
import DateRangeIcon from "@mui/icons-material/DateRange";

export default function AmbassadorDealMeetingsCard({ actualDeal }) {
    console.log("AmbassadorDealMeetingsCard", actualDeal.prospects)
    const app = useContext(AppContext);
    const goToMeetings = () => {
        window.location.replace("/e668ce390be04a6b88aa54d048a49b55?tab=rdv");
        //  window.location.replace("/e668ce390be04a6b88aa54d048a49b55/" + id + "?tab=rdv");

    };

    return (
        <CardTemplate
            title="Rendez-vous"
            buttons={<ButtonWithTooltipAndBadge
                tooltip="Gérer mon planning de rendez-vous"
                icon={<DateRangeIcon />}
                onclick_cb={
                    () => {
                        goToMeetings()
                    }}
                badge={false} />}
            content={
                <Stack>
                    {actualDeal.appointments.map((mtg) => (
                        <Paper
                            key={mtg.uid}
                            style="margin: 10px; padding: 5px; background-color: rgba(244, 246, 248, 0.81);"
                            onClick={() => {
                                window.location.replace("/e668ce390be04a6b88aa54d048a49b55?tab=rdv");
                            }}
                        >
                            <Stack spacing={1}>
                                <Box
                                    display="flex"
                                    alignItems="flex-start"
                                    justifyContent="space-between"
                                    style="padding: 0px; margin: 0px;"
                                >
                                    <Box>
                                        <Typography variant="h5">{mtg.date}</Typography>
                                    </Box>
                                    <Box>
                                        <Typography variant="body1">{mtg.start}</Typography>
                                    </Box>
                                    {mtg.cfrmd && (
                                        <Box p={1}>
                                            <AlarmOnIcon
                                                style={{
                                                    color: green[500],
                                                }}
                                            />
                                        </Box>
                                    )}
                                </Box>
                                {mtg.atnds.map((att) => (
                                    <Typography variant="body1">{att.name}</Typography>
                                ))}
                            </Stack>
                        </Paper>
                    ))}
                    {actualDeal.appointments.length === 0 && <em>Pas de rendez-vous</em>}
                </Stack>
            }
        />)

}
